import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./HeaderNew.module.css";
import { Button, Dialog } from "@mui/material";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import {
  formatDate,
  getPaymentStatus,
  getStatusById,
  getStatusByIds,
  steps,
} from "../../../Utility/utils";
import tick from "../../../assets/dashboard/tick.png";
import { PatchApi, getApi } from "../../../Utility/network";
import SelectStatus from "../../SelectStatus/SelectStatus";
import PaymentTransaction from "../../PaymentTransaction/PaymentTransaction";
import GenerateNeedCertificate from "../../GenerateNeedCertificate/GenerateNeedCertificate";
import ConnectPopUp from "../../ConnectPopUp/ConnectPopUp";
import { steps_german } from "../../../Pages/Need/utility/utils";
import { consumptionEngText, consumptionGermText } from "../../Pannel/Pannel";

function HeaderEnergy({ showDetails = false, ...props }) {
  let { id: _id } = useParams();
  const [item, setItem] = useState({});
  const { state, setState } = useContext(AppContext);
  const { language } = state;
  const [page, setPage] = useState(0);
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  // const [showForm, setShowForm] = useState(false);
  const [openConect, setOpenConnect] = useState(false);
  const [openRedeemedCode, setOpenRedeemedCode] = useState(false);

  useEffect(() => {
    setPage(state.needFilledPage);
  }, [state]);
  const [statusValue, setStatusValue] = useState({ status: "" });

  const handleClick = (_type, _index) => {
    if (_type === "past" || _type === "active") {
      setState((prev) => ({ ...prev, needPage: _index }));
    }
  };
  const fetchData = async (user_id) => {
    setState((prev) => ({
      ...prev,
      needData: {
        heatingSystemsCount: null,
        hotSystemsCount: null,
        construction_year: null,
        floor_details: [],
        roof_detail: {},
        basement_detail: {},
        insulation_details: [],
        windowDimension: false,
        active: {},
        insulation: false,
        heating_systems: [],
        hot_water_systems: [],
        are_renewable_energy_used: false,
        do_u_have_solar_collector: false,
        unobstructed_collector_area: null,
        number_of_air_conditioning_systems: 0,
        cooling_capacity: null,
        next_inspection_date: "",
        address: {
          direction_point: null,
          is_property_have_border_on_another_house: false,
          location: "",
          postcode: "",
          street: "",
        },
        billing_address: {
          order_type: 1,
          first_name: "",
          last_name: "",
          phone: null,
          postcode: null,
          location: "",
          email: "",
          company_name: "",
          vat_id: "",
          street: "",
        },
      },
      page: 1,
      filledPage: 1,
    }));
    try {
      const postData = await getApi(`/energy_need/user_energy_need/${user_id}`);
      setItem(postData.data);
      const {
        structure_detail,
        windowDimension,
        basement_detail,
        insulation_details,
        roof_detail,
        window_details,
        insulation,
        heating_systems,
        hot_water_systems,
        are_renewable_energy_used,
        do_u_have_solar_collector,
        unobstructed_collector_area,
        address,
        billing_address,
        building_type,
        construction_year,
        user,
        number_of_floors,
        occasion,
        number_of_apartments,
        floor_details,
        add_on_services,
        question,
        id,
        type_of_renewable_energy,
        number_of_air_conditioning_systems,
        cooling_capacity,
        next_inspection_date,
      } = postData.data;
      let page = 1;
      if (structure_detail && structure_detail.hasOwnProperty("id")) {
        page = 2;
      }

      if (basement_detail) {
        page = 3;
      }
      if (heating_systems && heating_systems.length > 0) {
        page = 4;
      }
      if (address) {
        page = 5;
      }
      if (billing_address) {
        page = 8;
      }

      setState((prev) => ({
        ...prev,
        needPage: page,
        needFilledPage: page,
        needId: id,
        walls: {
          ...prev.walls,
          structure_detail: structure_detail,
        },
        needData: {
          ...prev.needData,
          structure_detail: structure_detail
            ? structure_detail
            : { ...prev.needData.structure_detail },
          basement_detail,
          insulation_details,
          roof_detail,
          window_details,
          insulation,
          //   active: windowsNew.active,
          windowDimension,
          heating_systems,
          hot_water_systems,
          are_renewable_energy_used,
          do_u_have_solar_collector,
          unobstructed_collector_area,
          address,
          construction_year,
          billing_address,
          floor_details,
          Services: add_on_services,
          type_of_renewable_energy,
          number_of_air_conditioning_systems,
          cooling_capacity,
          next_inspection_date,
        },
        otherData: {
          ...prev.otherData,
          buildingData: {
            building_type_id: building_type?.id,
            construction_year,
            email: user?.email,
            number_of_floors,
            occasion_id: occasion?.id,
            number_of_apartments,
          },

          question: question,
        },
      }));
    } catch (error) {
      console.log("Error fetching data", error);
    }
  };
  useEffect(() => {
    fetchData(_id);
  }, [_id]);

  const handleIssue = async (type) => {
    setState((prev) => ({ ...prev, page: prev.page + 1 }));
    const postEnergy = await getApi(
      `energy_need/${state.needId}/calculate_energy_consumption/`
    );

    if (postEnergy.status === 200 || postEnergy.status === 201) {
      const generate_pdf = await getApi(
        `records/${postEnergy?.data?.data?.id}/generate_energy_certificate/`
      );
      if (generate_pdf.status === 200 || generate_pdf.status === 201) {
        setState((prev) => ({
          ...prev,
          pdfId: postEnergy?.data?.data?.id,
        }));
        if (type !== 2) {
          patchData(type, postEnergy);
        } else {
          navigate(
            `/consumption-certificate/${state.needId}/${postEnergy?.data?.data?.id}`
          );
        }
      }
    }
    // setShowForm(true);
  };

  const patchData = async (type, postEnergy) => {
    try {
      const postData = await PatchApi(`/energy_need/${state.needId}/`, {
        certificate_status: 2,
      });
      if (postData.status === 200 || postData.status === 201) {
        navigate(
          `/consumption-certificate/${state.needId}/${postEnergy?.data?.data?.id}`
        );
      }
    } catch (error) {}
  };
  const disblesCheck = item?.certificate_status !== 2;
  useEffect(() => {
    if (item?.payment_status) {
      setStatusValue({ status: getPaymentStatus(item?.payment_status) });
    }
  }, [item?.payment_status]);
  const DownloadDb = async (id) => {
    try {
      const response = await getApi(`/records/${id}/generate_debit_file/`);
      // setXml(response?.data?.data?.file);
      const xml = response?.data?.data?.file;
      if (xml) {
        const link = document.createElement("a"); // Create an anchor element
        link.href = xml; // Set the href to the XML URL
        link.download = xml; // Set the default file name to debit.xml
        document.body.appendChild(link); // Append the link to the body
        link.click(); // Programmatically click the link to trigger the download
        document.body.removeChild(link); // Remove the link after download
      } else {
        alert("XML file is not available.");
      }
    } catch (error) {
      console.error("Error generating debit file:", error);
    }
  };

  return (
    <div className={styles.header}>
      {showDetails && item && (
        <div className={styles.headDEtails}>
          <div className={styles.left}>
            <p 
              className={styles.name}
              style={{ textTransform: language === "en" ? "none" : "capitalize" }}
            >
              {item?.billing_address == null ? (
                <>
                  <span 
                    className={styles.fistLetter}
                    style={{ textTransform: language === "en" ? "none" : "capitalize" }}
                  >
                    {item?.user?.first_name} {item?.user?.last_name}{" "}
                  </span>
                  | {item?.user?.email}
                </>
              ) : (
                <>
                  <span 
                    className={styles.fistLetter}
                    style={{ textTransform: language === "en" ? "none" : "capitalize" }}
                  >
                    {item?.billing_address?.first_name}{" "}
                    {item?.billing_address?.last_name}
                  </span>{" "}
                  | {item?.billing_address?.email}
                </>
              )}
            </p>
            <p className={styles.submitted}>
              {" "}
              {language == "de"
                ? consumptionGermText?.submmited_on
                : consumptionEngText?.submmited_on}
            </p>
            <p className={styles.dates}>{formatDate(item.created)}</p>
          </div>
          <div className={styles.right}>
            <div className={styles.certificate}>
              <p className={styles.sname}>
                {language == "de" ? "Code eingelöst" : "Redeemed via Code"}
              </p>
              <p
                className={item?.is_package_redeemed ? styles.status2 : styles.status4}
                style={{ cursor: item?.is_package_redeemed ? "pointer" : "default" }}
                onClick={() => setOpenRedeemedCode(!!item?.is_package_redeemed)}
              >
                {item?.is_package_redeemed
                  ? (language == "de" ? "Ja" : "Yes")
                  : (language == "de" ? "Nein" : "No")}
              </p>
            </div>
            <div className={styles.certificate}>
              <p className={styles.sname}>
                {" "}
                {language == "de"
                  ? consumptionGermText?.Certificate
                  : consumptionEngText?.Certificate}
              </p>
              <div
                className={
                  getStatusById(item?.certificate_status) === "Draft" ||
                  getStatusById(item?.certificate_status) === "Entwurf"
                    ? styles.draft
                    : getStatusById(item?.certificate_status) === "Issued" ||
                      getStatusById(item?.certificate_status) === "Ausgestellt"
                    ? styles.issued
                    : getStatusById(item?.certificate_status) ===
                        "Correction Pending" ||
                      getStatusById(item?.certificate_status) ===
                        "Berichtigung anhängig"
                    ? styles.pending
                    : getStatusById(item?.certificate_status) ===
                        "Issued Version 2" ||
                      getStatusById(item?.certificate_status) ===
                        "Ausgegebene Version 2"
                    ? styles.issue2
                    : ""
                }
              >
                <span>{getStatusById(item?.certificate_status, language)}</span>
              </div>
            </div>
            {/* <div className={styles.certificate}>
              <p className={styles.sname}>Payment Status</p>
              <div
                style={{ width: "100%" }}
                // className={styles.status1}
                // style={{
                //   backgroundColor: `${
                //     item?.payment_status == 2
                //       ? "linear-gradient(90deg, #22a156 0%, #afdb28 100%)"
                //       : "#ffffff"
                //   }`,
                // }}
              >
                <SelectStatus
                  statusValue={statusValue}
                  setStatusValue={setStatusValue}
                />
              </div>
            </div> */}
            <div className={styles.certificate}>
              <p className={styles.sname}>
                {language == "de"
                  ? consumptionGermText?.payment_status
                  : consumptionEngText?.payment_status}
              </p>
              <p
                className={
                  getPaymentStatus(item?.payment_status) == "Pending" ||
                  getPaymentStatus(item?.payment_status) == "Anhängig"
                    ? styles.status1
                    : getPaymentStatus(item?.payment_status) == "Paid" ||
                      getPaymentStatus(item?.payment_status) == "Bezahlt"
                    ? styles.status2
                    : getPaymentStatus(item?.payment_status) == "Unpaid" ||
                      getPaymentStatus(item?.payment_status) == "Unbezahlt"
                    ? styles.status3
                    : getPaymentStatus(item?.payment_status) ==
                        "No payment required" ||
                      getPaymentStatus(item?.payment_status) ==
                        "Keine Zahlung erforderlich"
                    ? styles.status4
                    : ""
                }
                onClick={() => setOpen(true)}
              >
                {getPaymentStatus(item?.payment_status, language)}
              </p>
            </div>
            <div className={styles.certificate}>
              <p className={styles.sname}>
                {" "}
                {language == "de"
                  ? consumptionGermText?.issued_status
                  : consumptionEngText?.issued_status}
              </p>
              <p
                className={
                  getStatusByIds(item?.certificate_status)?.id !== 2
                    ? styles.draft
                    : styles.status2
                }
              >
                {getStatusByIds(item?.certificate_status)?.id !== null &&
                getStatusByIds(item?.certificate_status)?.id !== 2
                  ? language == "de"
                    ? "Nicht ausgestellt"
                    : "Not Issued"
                  : language == "de"
                  ? "Ausgestellt"
                  : "Issued"}
              </p>
            </div>
            <Button
              variant="contained"
              sx={{
                padding: "12px 25px",
                background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                boxShadow: "none",
                borderRadius: "10px",
                color: "white",
                "&:disabled": {
                  background: "gray",
                  color: "#ccc",
                },
              }}
              // disabled={!item?.power_consumption?.id}
              onClick={() => setOpenConnect(true)}
            >
              {language == "de"
                ? consumptionGermText?.connect
                : consumptionEngText?.connect}
            </Button>
            <Button
              variant="contained"
              sx={{
                padding: "12px 25px",
                background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                boxShadow: "none",
                borderRadius: "10px",
                color: "white",
                "&:disabled": {
                  background: "gray",
                  color: "#ccc",
                },
              }}
              disabled={!item?.power_consumption?.id}
              onClick={() => DownloadDb(item?.power_consumption?.id)}
            >
              DIBt XML
            </Button>
          </div>
        </div>
      )}
      <div className={styles.stepsCon}>
        {(language === "de" ? steps_german : steps).map((steps, index) => {
          let ui;
          if (index + 1 === page) {
            ui = "active";
          } else if (index + 1 < page) {
            ui = "past";
          } else {
            ui = "future";
          }
          return (
            <div
              className={
                ui === "past"
                  ? `${styles.steps} ${styles.stepsa}`
                  : `${styles.steps} ${styles.stepsin}`
              }
            >
              <div className={styles.stepContainer}>
                <div
                  className={styles.circle}
                  style={{
                    border: `${
                      ui === "past"
                        ? "3px solid #008C76"
                        : ui === "future"
                        ? "3px solid #DDCA2380"
                        : "3px solid #ddca23"
                    }`,
                    background: `${
                      ui === "past"
                        ? "#008C76"
                        : ui === "future"
                        ? "#DDCA2380"
                        : ""
                    }`,
                    cursor: `${
                      ui === "past" || ui === "active" ? "pointer" : "auto"
                    }`,
                  }}
                  onClick={() => handleClick(ui, index + 1)}
                >
                  {ui === "active" && (
                    <div
                      className={styles.innerCircle}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    ></div>
                  )}
                  {ui === "past" && (
                    <img src={tick} className={styles.imgWid} />
                  )}
                </div>
              </div>
              <div className={styles.about}>
                <p className={styles.step}>{steps.step}</p>
                {steps.info.split("\n").map((line, index) => (
                  <p className={styles.stepName} key={index}>
                    {line}
                  </p>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      {open && (
        <PaymentTransaction
          open={open}
          handleClose={() => setOpen(false)}
          data={item}
          fetchData={fetchData}
        />
      )}
      {openConect && (
        <ConnectPopUp
          open={openConect}
          handleClose={() => setOpenConnect(false)}
        />
      )}
      <Dialog open={openRedeemedCode} onClose={() => setOpenRedeemedCode(false)} maxWidth="sm" fullWidth>
        <div style={{ padding: "20px" }}>
          <h3 style={{ marginBottom: "15px", fontFamily: '"Montserrat", sans-serif' }}>
            {language === "de" ? "Informationen zum eingelösten Code:" : "Redeemed Code Information:"}
          </h3>
          <p style={{ margin: "5px 0", fontSize: "14px" }}>
            <strong>{language === "de" ? "Code:" : "Code:"}</strong> {item?.redeemed_code}
          </p>
          <p style={{ margin: "5px 0", fontSize: "14px" }}>
            <strong>{language === "de" ? "Käufer:" : "Buyer:"}</strong> {item?.original_buyer_name} ({item?.original_buyer_email})
          </p>
          <p style={{ margin: "5px 0", fontSize: "14px" }}>
            <strong>{language === "de" ? "Paket:" : "Package:"}</strong> {item?.package_name}
          </p>
          <p style={{ margin: "5px 0", fontSize: "14px" }}>
            <strong>{language === "de" ? "Verbleibend:" : "Remaining:"}</strong> {item?.redeemed_code_remaining} / {item?.redeemed_code_original}
          </p>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
            <Button variant="contained" onClick={() => setOpenRedeemedCode(false)} sx={{ backgroundColor: "#008C76", "&:hover": { backgroundColor: "#006c5a" } }}>
              {language === "de" ? "Schließen" : "Close"}
            </Button>
          </div>
        </div>
      </Dialog>
      {/* <GenerateNeedCertificate show={showForm} setShow={setShowForm} /> */}
    </div>
  );
}

export default HeaderEnergy;
